import { signalStore, type, withState } from '@ngrx/signals';
import { eventGroup, on, withReducer } from '@ngrx/signals/events';

interface GlobalLoadingState {
  message: string | null;
  progress: number | null;
}

const initialState: GlobalLoadingState = {
  message: null,
  progress: null,
};

export const globalLoading = eventGroup({
  source: 'Global Loading',
  events: {
    set: type<{ message: string | null; progress: number | null }>(),
    clear: type<void>(),
  },
});
export const GlobalLoadingStore = signalStore(
  withState(initialState),
  withReducer(
    on(globalLoading.set, ({ payload: { message, progress } }) => ({
      message,
      progress,
    })),
    on(globalLoading.clear, () => ({ message: null, progress: null })),
  ),
);
